<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import { isPhoneE164OrEmpty } from 'shared/helpers/Validators';

export default {
  components: {
    PageHeader,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      phoneNumber: '',
      // apiToken: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
    phoneNumber: { required, isPhoneE164OrEmpty },
    // apiToken: {required},
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const zaloChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName,
            channel: {
              type: 'zalo',
              phone_number: this.phoneNumber,
              // channel_config: {
              //   api_token: this.apiToken
              // },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: zaloChannel.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.ZALO_CHANNEL.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>

<template>
  <div
    class="border border-slate-25 dark:border-slate-800/60 bg-white dark:bg-slate-900 h-full p-6 w-full max-w-full md:w-3/4 md:max-w-[75%] flex-shrink-0 flex-grow-0"
  >
    <PageHeader
      :header-content="$t('INBOX_MGMT.ADD.ZALO_CHANNEL.DESC')"
      :header-title="$t('INBOX_MGMT.ADD.ZALO_CHANNEL.TITLE')"
    />
    <form class="flex flex-wrap mx-0" @submit.prevent="createChannel()">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: v$.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.ZALO_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model="channelName"
            :placeholder="
              $t('INBOX_MGMT.ADD.ZALO_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            type="text"
            @blur="v$.channelName.$touch"
          />
          <span v-if="v$.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.ZALO_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: v$.phoneNumber.$error }">
          {{ $t('INBOX_MGMT.ADD.ZALO_CHANNEL.PHONE_NUMBER.LABEL') }}
          <input
            v-model="phoneNumber"
            :placeholder="
              $t('INBOX_MGMT.ADD.ZALO_CHANNEL.PHONE_NUMBER.PLACEHOLDER')
            "
            type="text"
            @blur="v$.phoneNumber.$touch"
          />
          <span v-if="v$.phoneNumber.$error" class="message">
            {{ $t('INBOX_MGMT.ADD.ZALO_CHANNEL.PHONE_NUMBER.ERROR') }}
          </span>
        </label>
      </div>

      <!--      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">-->
      <!--        <label :class="{ error: v$.apiToken.$error }">-->
      <!--        <span>-->
      <!--          {{ $t('INBOX_MGMT.ADD.ZALO_CHANNEL.API_TOKEN.LABEL') }}-->
      <!--        </span>-->
      <!--          <input-->
      <!--              v-model="apiToken"-->
      <!--              :placeholder="$t('INBOX_MGMT.ADD.ZALO_CHANNEL.API_TOKEN.PLACEHOLDER')"-->
      <!--              type="text"-->
      <!--              @blur="v$.apiToken.$touch"-->
      <!--          />-->
      <!--          <span v-if="v$.apiToken.$error" class="message">-->
      <!--          {{ $t('INBOX_MGMT.ADD.ZALO_CHANNEL.API_TOKEN.ERROR') }}-->
      <!--        </span>-->
      <!--        </label>-->
      <!--      </div>-->

      <div class="w-full">
        <woot-submit-button
          :button-text="$t('INBOX_MGMT.ADD.ZALO_CHANNEL.SUBMIT_BUTTON')"
          :loading="uiFlags.isCreating"
        />
      </div>
    </form>
  </div>
</template>
